import classNames from 'classnames'

import styles from './Category.module.scss'

type Props = {
  title: string
  count: number
  className?: string
}

export const Category = ({ title, count, className }: Props) => {
  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.text}>{title}</div>
      <div className={styles.count}>{count}</div>
      <svg className={styles.icon} viewBox="0 0 15 20" fill="none">
        <path
          d="M7.5 0.32C9.30 0.32 10.97 1.35 12.19 3.07C13.41 4.80 14.18 7.20 14.18 9.86C14.18 12.53 13.41 14.93 12.19 16.65C10.97 18.38 9.30 19.41 7.5 19.41C5.70 19.41 4.03 18.38 2.81 16.65C1.59 14.93 0.82 12.53 0.82 9.86C0.82 7.20 1.59 4.80 2.81 3.07C4.03 1.35 5.70 0.32 7.5 0.32Z"
          stroke="#D6D6D6"
          strokeWidth="0.636364"
        />
      </svg>
    </div>
  )
}
